/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Copy_FailedInputs */



/**
* | output |
* | --- |
* | "Couldn't copy the decklist" |
*
* @param {Deck_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_copy_failed = /** @type {((inputs?: Deck_Copy_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Copy_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de copier la liste de deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo copiar la lista de mazo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível copiar a lista de deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile copiare la lista del mazzo")
	return /** @type {LocalizedString} */ ("Couldn't copy the decklist")
});